import { isValidEmailAddress } from "@productlane/lib/src/email-domain"

export const RECIPIENT_SEPARATORS = [",", ";"]

// Addresses copied out of a sentence keep its full stop ("ada@acme.co.uk.").
export function normalizeEmailInput(rawEmail: string): string {
	return rawEmail.trim().toLowerCase().replace(/\.+$/, "")
}

// Mail clients hand over "Name <a@b.com>" or a bare address, either way wrapped
// in whatever quoting the source used.
function extractEmail(chunk: string): string {
	const angled = /<([^>]+)>/.exec(chunk)
	const candidate = angled?.[1] ?? chunk
	return normalizeEmailInput(candidate.replace(/^["']|["']$/g, ""))
}

/**
 * Splits pasted or typed text on commas, semicolons, and newlines, keeping only
 * addresses that parse. Duplicates collapse, so pasting a list twice is a no-op.
 */
export function parseRecipientInput(text: string): string[] {
	const seen = new Set<string>()
	for (const chunk of text.split(/[,;\n\r\t]+/)) {
		if (!chunk.trim()) continue
		const email = extractEmail(chunk)
		if (isValidEmailAddress(email)) seen.add(email)
	}
	return [...seen]
}

export function isRecipientSeparator(key: string): boolean {
	return RECIPIENT_SEPARATORS.includes(key)
}
